import axios from "axios";
import AuthServices from "./AuthServices";
import queryString from "query-string";
import URLHelper from "../helpers/URLHelper";

const DashServices = {
  getProtocols: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/eira/protocol"
    );
    return response;
  },
  getSubscriptions: async (id = null, data) => {
    const args = id === null ? "" : `&id=${id}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/subscription?${queryString.stringify(data)}${args}`
    );
    return response;
  },
  getAvailableSubscriptions: async (contact = null, role = null) => {
    const args = contact === null ? "" : `?contact=${contact}&rol=${role}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/available-subscriptions${args}`
    );
    return response;
  },
  cloneSubscriptions: async (subscription_id) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/service/clone-subscription`,
      {
        subscription_id: subscription_id,
      }
    );
    return response;
  },
  deleteSubscriptions: async (subscription_id = null) => {
    const args = subscription_id === null ? "" : `?id=${subscription_id}`;
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `/eira/subscription${args}`
    );
    return response;
  },
  getEnterprises: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/enterprise`
    );
    return response;
  },

  getActivePatients: async (values) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/service/patients-actived",
      {
        params: {
          days: values.period,
          subscription: values.suscription,
        },
      }
    );
    return response;
  },

  getRegisteredPatients: async (values) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/service/patients-registered",
      {
        params: {
          days: values.period,
          subscription: values.suscription,
        },
      }
    );
    return response;
  },

  getSubscriptionsUser: async (id) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/subscription-user?id=${id}`,
      {
        params: {},
      }
    );
    return response;
  },

  deleteSubscriptionsUser: async (subscription_id, username) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `/eira/subscription-user`,
      {
        params: {
          subscription: subscription_id,
          username: username,
        },
      }
    );
    return response;
  },

  getMedicines: async (subscription_id) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/medicine?subscription=${subscription_id}`
    );
    return response;
  },

  getSubscriptionMedicine: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/subscription-medicine`
    );
    return response;
  },

  getMedicineTaken: async (medicine_id, patient, date_from, date_to) => {
    let args = "";
    if (date_from) args += `&date_from=${date_from}`;
    if (date_to) args += `&date_to=${date_to}`;

    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/medicine-taken?vademecum_medicine=${medicine_id}&patient=${URLHelper.encodeQueryParamValue(patient)}${args}`
    );
    return response;
  },

  OutRangeMedicine: async (days, subscription, data) => {
    let args = "";
    if (data) {
      args = `&${queryString.stringify(data)}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/out-of-range-medicine?days=${days}&subscription_id=${subscription}${args}`
    );
    return response;
  },

  OutRangeAutoevaluate: async (days, subscription, data) => {
    let args = "";
    if (data) {
      args = `&${queryString.stringify(data)}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/out-of-range-survey?days=${days}&subscription_id=${subscription}${args}`
    );
    return response;
  },

  OutRangeRPM: async (days, suscription, patient, data) => {
    let args = "";
    if (data) {
      args = `&${queryString.stringify(data)}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/out-of-range-rpm?days=${days}&patient=${URLHelper.encodeQueryParamValue(patient)}&subscription_id=${suscription}${args}`
    );
    return response;
  },

  OutRangeLogBook: async (days, suscription, patient, data) => {
    let args = "";
    if (data) {
      args = `&${queryString.stringify(data)}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/out-of-range-feeding?days=${days}&patient=${URLHelper.encodeQueryParamValue(patient)}&subscription_id=${suscription}${args}`
    );
    return response;
  },

  OutRangeFeeding: async (days, patient, suscription = "") => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/out-of-range-feeding?days=${days}&patient=${URLHelper.encodeQueryParamValue(patient)}&subscription_id=${suscription}`
    );
    return response;
  },

  updateRange: async (args) => {
    let data = {
      type: args.type, // sistolico, diastolico, fc, peso, diabetes, insulina, alimentos
      max_value_alert: parseInt(args.max_value_alert),
      max_value: parseInt(args.max_value),
      min_value: parseInt(args.min_value),
      min_value_alert: parseInt(args.min_value_alert),
    };
    if (args.module !== undefined) {
      data = { ...data, module: args.module };
    }
    if (args.patient !== undefined) {
      data = { ...data, patient: args.patient };
    }
    if (args.module !== undefined) {
      data = { ...data, module: args.module };
    }
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/range`,
      data
    );
    return response;
  },

  updateCheckboxRange: async (args) => {
    let data = {
      patient: args.patient,
      data: [],
    };
    if (args.max_value_alert !== undefined) {
      data.data.push({
        type: args.type,
        field: "max_value_alert",
        check: args.max_value_alert,
      });
    }
    if (args.max_value !== undefined) {
      data.data.push({
        type: args.type,
        field: "max_value",
        check: args.max_value,
      });
    }
    if (args.min_value !== undefined) {
      data.data.push({
        type: args.type,
        field: "min_value",
        check: args.min_value,
      });
    }
    if (args.min_value_alert !== undefined) {
      data.data.push({
        type: args.type,
        field: "min_value_alert",
        check: args.min_value_alert,
      });
    }

    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/range-check`,
      data
    );
    return response;
  },

  GetInterventions: async (days, user) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/intervention?days=${days}&patient=${URLHelper.encodeQueryParamValue(user)}`
    );
    return response;
  },

  searchMedicine: async (name, subscription, data) => {
    let args = "";
    if (data) {
      args = `&${queryString.stringify(data)}`;
    }
    const response = await axios.post(
      process.env.REACT_APP_API_URL +
        `/service/bo-search-medicine?${queryString.stringify(data)}`,
      {
        query: name,
        subscription: subscription,
        ...data,
      }
    );
    return response;
  },

  getProtocolActiveDays: async (patient, subscription_id) => {
    const args = `?patient=${URLHelper.encodeQueryParamValue(patient)}&subscription_id=${subscription_id}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/service/active-days${args}`
    );
    return response;
  },

  getSelfEvaluationsAnswer: async (
    patient,
    survey_answer_id = null,
    survey_id = null
  ) => {
    let args = `?patient=${URLHelper.encodeQueryParamValue(patient)}`;
    if (survey_answer_id !== null) {
      args += `&survey_answer_id=${survey_answer_id}`;
    }
    if (survey_id !== null) {
      args += `&survey_id=${survey_id}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/survey/answer${args}`
    );
    return response;
  },

  getSelfEvaluationsAssign: async (patient) => {
    const args = `?username=${URLHelper.encodeQueryParamValue(patient)}`;
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/survey/assign${args}`
    );
    return response;
  },

  savePill: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/pill`,
      {
        enterprises: data.enterprises,
        type: data.type,
        name: data.name,
        description: data.description,
        ...(data.type === "education" ? { url: data.url } : null),
        capsule_strapi_id: data.capsule_strapi_id,
      }
    );
    return response;
  },
};

export default DashServices;
